import React from "react";
import { motion } from "framer-motion";
import { Map, Upload, Sparkles, ShoppingCart, TrendingUp } from "lucide-react";
import { useT } from "@/i18n";

export default function Roadmap() {
  const t = useT();

  const phases = [
    {
      key: "import", icon: Upload, title: t("roadmap.phaseImport"), status: t("roadmap.statusNext"), tone: "bg-brand/10 text-brand",
      items: [t("roadmap.importShopify"), t("roadmap.importWoo"), t("roadmap.importCsv")],
    },
    {
      key: "ai", icon: Sparkles, title: t("roadmap.phaseAi"), status: t("roadmap.statusNext"), tone: "bg-brand/10 text-brand",
      items: [t("roadmap.realAiProvider"), t("roadmap.openaiConnector"), t("roadmap.mcpConnector"), t("roadmap.acpConnector"), t("roadmap.ucpConnector")],
    },
    {
      key: "commerce", icon: ShoppingCart, title: t("roadmap.phaseCommerce"), status: t("roadmap.statusPlanned"), tone: "bg-warning/10 text-warning",
      items: [t("roadmap.checkout"), t("roadmap.orders"), t("roadmap.payments"), t("roadmap.shipping"), t("roadmap.customers")],
    },
    {
      key: "growth", icon: TrendingUp, title: t("roadmap.phaseGrowth"), status: t("roadmap.statusFuture"), tone: "bg-secondary text-muted-foreground",
      items: [t("roadmap.marketplace"), t("roadmap.analytics"), t("roadmap.aiVisibility")],
    },
  ];

  return (
    <div>
      <h1 className="flex items-center gap-2 font-display text-3xl font-extrabold tracking-tighter">
        <Map className="h-6 w-6 text-brand" />{t("roadmap.title")}
      </h1>
      <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{t("roadmap.subtitle")}</p>

      <div className="mt-8 grid gap-4 md:grid-cols-2" data-testid="roadmap-grid">
        {phases.map((p, i) => (
          <motion.div key={p.key} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35, delay: i * 0.06 }}
            className="rounded-lg border border-border bg-card p-6" data-testid={`roadmap-phase-${p.key}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-brand/10 text-brand"><p.icon className="h-4 w-4" /></span>
                <h3 className="font-display text-lg font-bold">{p.title}</h3>
              </div>
              <span className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${p.tone}`}>{p.status}</span>
            </div>
            <ul className="mt-4 space-y-2">
              {p.items.map((it) => (
                <li key={it} className="flex items-center gap-2 rounded-md border border-border px-3 py-2 text-sm">
                  <span className="h-1.5 w-1.5 rounded-full bg-brand" />{it}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
